import { ErrorReporter } from '../errorReporter.type';
import { AdSlotsConfigurationByPlatform, AdSlotsUnits } from './ads.types';

declare global {
  interface Window { apstag: any }
}

export const getApsTagTimeoutInMilliseconds = () => 1000;

export const apstagInit = (amazonPublisherId: string, adServerName: string, errorProvider: ErrorReporter) => {
  if (!window.apstag || !window.apstag.init) {
    errorProvider.reportException({
      name: 'apstag',
      message: 'window.apstag or window.apstag.init is not defined. Amazon Header Bidding script probably was not executed on time, therefore ads will not render',
    });
    return;
  }
  window.apstag.init({
    pubID: amazonPublisherId,
    adServer: adServerName,
    bidTimeout: getApsTagTimeoutInMilliseconds(),
  });
};

const createSlots = (adSlotsConfigurationByPlatform: AdSlotsConfigurationByPlatform, units: AdSlotsUnits) => {
  return Object.entries(adSlotsConfigurationByPlatform).reduce((acc: Array<object>, [unitKey, unitConf]) => {
    const { adUnitPath, sizes } = unitConf;
    return [
      ...acc,
      {
        slotID: units[unitKey],
        slotName: adUnitPath,
        sizes,
      },
    ];
  }, []);
};

export const apstagFetchBids = (adSlotsConfigurationByPlatform: AdSlotsConfigurationByPlatform, units: AdSlotsUnits, adServerCallback: Function, errorProvider: ErrorReporter) => {
  if (!window.apstag || !window.apstag.fetchBids) {
    errorProvider.reportException({
      name: 'apstag',
      message: 'window.apstag or window.apstag.fetchBids is not defined. Amazon Header Bidding script probably was not executed on time, therefore ads will not render',
    });
    return;
  }
  window.apstag.fetchBids({
    slots: createSlots(adSlotsConfigurationByPlatform, units),
  }, adServerCallback(() => window.apstag.setDisplayBids()));
};
